export default "__VITE_ASSET__D9ZqsSJe__"